import React from 'react';

export default function Modal({ isOpen, onClose, title, children, size }) {
  if (!isOpen) return null;
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div className="card" style={{ width: size || '500px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="flex justify-between items-center mb-2">
          <h3>{title}</h3>
          <button className="btn btn-sm btn-secondary" onClick={onClose}>X</button>
        </div>
        {children}
      </div>
    </div>
  );
}